import React, { Dispatch, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useInternal } from "uikit";
import { cloneDeep, defaults } from "lodash";

import { LightInputModal } from "../../../../../../../../../../components";
import { useCheckFlagAccessControl } from "../../../../../../../../../../hooks";
import { TabAccessNames, TabKeys } from "../../constants/access";

import Content from "./components/Content";
import Footer from "./components/Footer";

const FilterOrdersByCarModal: React.FC<FilterOrdersByCarModal.Props> = ({
	onClose,
	onReset,
	onSubmit,

	...props
}) => {
	const { t } = useTranslation();
	const checkFlagAccessControl = useCheckFlagAccessControl(TabAccessNames);

	const outerValue = useMemo(
		() =>
			defaults(cloneDeep(props.value ?? {}), {
				type: checkFlagAccessControl[TabKeys.FLEET_NUMBER]
					? "garage"
					: "state",
				number: "",
			}),
		[checkFlagAccessControl, props.value],
	);

	const [value, setValue] = useInternal<Content.Value>(outerValue);

	const internalOnSubmit = useCallback(() => {
		onSubmit?.(value);
	}, [onSubmit, value]);

	return (
		<LightInputModal
			{...props}
			draggable={false}
			useDefaultFooter={false}
			title={
				t(
					"pages.mainPage.pages.orders.orderHeader.firstRow.filterOrdersByCarModal.str0",
				) ?? ""
			}
			onClose={onClose}
			onSubmit={internalOnSubmit}
		>
			<Content value={value} onChange={setValue} />
			<Footer
				onCancel={onClose}
				onReset={onReset}
				onSubmit={internalOnSubmit}
			/>
		</LightInputModal>
	);
};

declare namespace FilterOrdersByCarModal {
	type Value = Content.Value;

	interface Props
		extends Omit<
			LightInputModal.Props,
			"draggable" | "title" | "onSubmit"
		> {
		value?: Partial<Value>;

		onReset?: () => void;
		onSubmit?: Dispatch<Value>;
	}
}

export default FilterOrdersByCarModal;
